export const tableData = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '减分项',
    },
    {
      key: 'extraid',
      dataIndex: 'extraid',
      title: '关联指标',
    },
    {
      title: '警示减分建议',
      slot:'jf',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  },
};
